// import ScrollWatcher from './ScrollWatcher';


class AjaxForm {


	get_defaults() {

		return {
			action: 'do_ajax',
			lazy: false,
			auto_submit: false,
			sel_output: '.ajax-output',
			sel_pagination: '.pagination',
			paged: 1,
			store_query_id: false,
			on_success: function() {},
			on_html: function() {},
			on_fragment: function() {},
			after_done: function() {},
			after_read_from_storage: function() {},
		}

	}

	get_settings() {
		return this.settings;
	}

	after_done() {
		this.write_to_storage();

	}

	storage() {
		
		this.settings.storage_key = false;

		if (typeof(Storage) !== 'undefined' && this.settings.store_query_id) {
			this.settings.storage_key = 'ajax_form_data_' + this.settings.store_query_id;
			this.read_from_storage();
		}
	}

	clear_storage() {
		if(this.settings.storage_key) {
			localStorage.removeItem(this.settings.storage_key);
		}
	}

	read_from_storage() {

		if(!this.settings.storage_key) {
			return false;
		}

		var ajax_form_data = localStorage.getItem(this.settings.storage_key);
		
		if(ajax_form_data !== null && ajax_form_data.length) {
			
			var current_form_data = this.get_form_data();

			if(ajax_form_data == JSON.stringify(current_form_data)) {
				return;
			}

			var form_data = JSON.parse(ajax_form_data);

			$.each(form_data, (index, value) => {
				this.$form.find('[name="' + index + '"]').each((field_i, field) => {

					var $field = $(field),
						input_type = field.type;

					if(input_type == 'radio' || input_type == 'checkbox') {
						if($field.val() == value) {
							$field.prop( 'checked', true );
						}
					} else {
						$field.val(value);
					}
				});

			});

			if($.isFunction(this.settings.after_read_from_storage)) {
				this.settings.after_read_from_storage( form_data );
			}

			this.$form.submit();
		}
	}
	
	write_to_storage() {

		if(this.settings.storage_key) {

		var form_data = this.get_form_data();

			var json_form_data = JSON.stringify(form_data);
			localStorage.setItem(this.settings.storage_key, json_form_data);

		}

	}

	constructor( form, options ) {

		// eslint-disable-next-line no-undef	
		var ajax_settings = (typeof ajax_object === 'undefined') ? {} : ajax_object;
		// eslint-disable-next-line no-undef	
		console.log('ajax_object', ajax_object);
		this.settings = $.extend({}, this.get_defaults(), ajax_settings, (options !== undefined ? options : {}));

		this.form = form;
		this.$form = $(form);
		this.$output = $(form).find(this.settings.sel_output);
		this.$pagination = $(form).find(this.settings.sel_pagination);

		if(this.$form.hasClass('auto-submit')) {
			this.settings.auto_submit = true;
		}

		if(this.$form.hasClass('lazy-load')) {
			this.settings.lazy = true;
		}	
		
		this.$form.on('submit', (e) => {
			e.preventDefault();
			this.on_submit(e);
		});		
		
		this.$form.on('reset', (e) => {
			this.on_reset(e);
		});
		
		this.auto_submit();
		this.pagination();
		this.lazy();

		if(this.$form.hasClass('init-submit')) {
			this.$form.submit();
		}

		this.storage();
		

	}

	get_form_data() {

		var o = {};
		var a = this.$form.serializeArray();
		
		$.each(a, function() {
			if (o[this.name]) {
				if (!o[this.name].push) {
					o[this.name] = [o[this.name]];
				}
				o[this.name].push(this.value || '');
			} else {
				o[this.name] = this.value || '';
			}
		});

		return o;
	}

	auto_submit() {


		this.$form.on('change', ':input', (e) => {

			var $field = $(e.target);

			if($field.attr('name') !== 'paged') {
				this.$form.find('[name="paged"]').val(1);
			} else {
				this.$form.submit();
				return;				
			}

			if( (this.settings.auto_submit || $field.hasClass('auto-submit')) && !$field.hasClass('no-auto-submit') ) {
				this.$form.submit();
			}

		});

	}

	pagination() {

		var $pagination = $(this.settings.sel_pagination);

		if(this.settings.lazy) {
			$pagination.wrap('<div class="pagination-wrap"></div>').parent().hide();
		}


		this.$form.on(
			'click',
			this.settings.sel_pagination + ' .pg-change', 
			(e) => {

			e.preventDefault();

			var $paged_field = this.$form.find('[name="paged"]'),
				$btn = $(e.target).hasClass('pg-change') ? $(e.target) : $(e.target).closest('.pg-change'),
				page_n = $btn.data('pg-n');

			$paged_field.val(page_n).first().trigger('change');

		});
	}

	before_submit() {}

	validate() {
		this.clear_errors();
	}

	is_valid() {
		return this.get_errors().length === 0;
	}

	clear_errors() {
		this._errors = [];

		if(this.$err_el !== undefined && this.$err_el !== null && this.$err_el.length) {
			this.$err_el.remove();
			this.$err_el = null;
		}

	}

	get_errors() {
		return this._errors;
	}

	show_errors() {

		var errors = this.get_errors();

		if(!errors.length) return;

		if(this.$err_el === undefined || this.$err_el === null || !this.$err_el.length) {
			this.$err_el = $('<ul class="errors"></ul>');
			this.$err_el.insertAfter(this.$output);
		} else {
			this.$err_el.html('');
		}

		$.each(errors, (index, msg) => {
			this.$err_el.append('<li class="error">' + msg + '</li>');
		});

	}

	add_error( msg ) {
		return this._errors.push(msg);
	}

	on_submit() {

		this.before_submit();

		this.validate();

		if(this.is_valid()) {
			this.do_ajax();
		} else {
			this.kill_ajax();
			this.show_errors();
		}
	}

	on_reset() {

		var $no_resets = this.$form.find('.no-reset');

		$no_resets.each(function(index, el) {
			var $field = $(el);

			if(el.type == 'radio' || el.type == 'checkbox') {
				$field.data('prereset_checked', el.checked );
			} else {
				$field.data('prereset_val', $field.val() );

			}
		});

		// console.log('on_reset', e);

		var auto_submit = this.settings.auto_submit,
			$paged_field = this.$form.find('[name="paged"]');

		this.settings.auto_submit = false;
		
		setTimeout(() => {
			
			$no_resets.each(function(index, el) {
				var $field = $(el);

				if(el.type == 'radio' || el.type == 'checkbox') {
					el.checked = $field.data('prereset_checked');
					$field.removeData('prereset_checked');

				} else {
					$field.val($field.data('prereset_val'));
					$field.removeData('prereset_val');
				}
			});
			// executes after the form has been reset

			$paged_field.val(1);

			this.$form.find(':input').trigger('change');

			this.settings.auto_submit = auto_submit;

			if(this.settings.auto_submit) {
				this.$form.submit();
			}

		}, 1);
		

	}

	kill_ajax() {

		if(this.xhr !== undefined) {
			this.xhr.abort();
			this.is_loading = false;
			this.$form.removeClass('ajax-loading');
		}
	}
	
	do_ajax() {

		var settings = this.get_settings();
		
		this.kill_ajax();
		this.clear_storage();

		this.$form.addClass('ajax-loading');
		this.is_loading = true;

		var query_data = $.extend({}, settings.wp_query_vars, this.get_form_data()),
			ajax_data = $.extend(
				{action: settings.action},
				query_data
			);


		this.xhr = $.ajax({
				url: settings.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: ajax_data,
			})
			.done((data) => {

				this.is_loading = false;
				this.$form.toggleClass('ajax-loading', this.is_loading);

				if(data.html !== undefined && data.html !== false) {
					this.handle_html(data.html);
				}

				if(data.fragments !== undefined) {
					this.handle_fragments(data.fragments);
				}

				if($.isFunction(this.settings.on_success)) {
					this.settings.on_success(data);
				}


				// console.log('TRIGGER WINDOW RESIZE');
				// $(window).trigger('resize');

				if($.isFunction(this.settings.after_done)) {
					console.log('this.settings.after_done');
					this.settings.after_done();
				}

				this.after_done();

			})
			.fail(() => {
				this.is_loading = false;
				this.$form.toggleClass('ajax-loading', this.is_loading);
				// console.log("error");
			})
			// eslint-disable-next-line no-unused-vars
			.always((data) => {

				// console.log("complete");

			});
	}

	lazy() {
		/*		
		if(!this.settings.lazy) {
			return;
		}

		this.scroll_watcher = new ScrollWatcher( this.$output, {
			on_update :	(watcher) => {				
					if(watcher.get_state('bot_in')) {
						this.do_lazy();
					} 
				},
		} );

		setTimeout(function() {
			$( window ).resize();
		}, 1000);
*/
	}

	do_lazy() {

		if(this.is_loading) {
			return;
		}

		
		var $paged_field = this.$form.find('[name="paged"]'),
			$n_pages_field = this.$form.find('[name="n_pages"]'),
			page_n = parseInt($paged_field.val()),
			n_pages = parseInt($n_pages_field.val());

		if(page_n < n_pages) {

			$paged_field.val(page_n + 1);
			
			this.append = true;
			this.$form.submit();

		}

	}

	handle_html( html ) {

		if(this.settings.lazy && this.append) {
			this.append = false;
			var current_html = this.$output.html();
			this.$output.html(current_html + html);
		} else {
			this.$output.html(html);
		}

		if($.isFunction(this.settings.on_html)) {
			this.settings.on_html();
		}

	}

	handle_fragments( fragments ) {

		if(fragments.hide != null && fragments.hide.length) {
			$.each(fragments.hide, ( i, sel ) => {
				let hide = true;
				if(sel.charAt(0) == '!') {
					hide = false;
					sel = sel.substring(1);
				}
				this.$form.find(sel).toggleClass('hidden', hide);
			});
			delete fragments.hide;
		}

		if(fragments.append != null) {
			$.each(fragments.append, ( sel, html ) => {
				this.$form.find(sel).append(html);
			});
			delete fragments.append;
		}

		$.each(fragments, ( sel, el ) => {
			this.$form.find(sel).replaceWith(el);
		});

		if($.isFunction(this.settings.on_fragment)) {
			this.settings.on_fragment();
		}
	}



}

export default AjaxForm



// WEBPACK FOOTER //
// ./scripts/util/AjaxForm.js